let moment = require('moment');

const formatDate = (date) => {
    return moment(date).format("DD/MM/YYYY");
}

export const formatUTC = (date) => {
    return new Date(date);
}


export const toDate = (dateStr) => {
    if (dateStr) {
        var parts = dateStr.split("/");
        return new Date(parts[2], parts[1] - 1, parts[0]);
    }
}

export const dateDiffDays = (initial, final) => {
    var a = moment(initial);
    var b = moment(final);
    return b.startOf('day').diff(a.startOf('day'), 'days');
    
}



export default formatDate;